module.exports = __webpack_public_path__ + "img/hezuo.8615a885.png";